import React from "react";
import styles from './PageLoader.module.css';

const PageLoader = () => {
  return (
    <div id="page-loader" className={styles.pageLoader}>Chargement...</div>
  );
};

export default PageLoader;